import dict from '@/api/dict';
import dictTypes from '@/utils/dictTypes.js';
const state = {
	allDictListData: {}
};
const mutations = {
	SET_ALL_DICT_LIST: (state, obj) => {
		state.allDictListData = obj;
	}
};
const actions = {
	clearAllStore({ commit }) {
		commit('SET_ALL_DICT_LIST', {});
	},
	// 批量获取所有字典值
	getAllDictList({ commit, state }) {
		return new Promise((resolve, reject) => {
			if (!state.allDictListData.success) {
				dict.getListByTypes(dictTypes).then(result => {
					commit('SET_ALL_DICT_LIST', result);
					resolve(result);
				}).catch(error => {
					reject(error);
				})
			}
		})
	}
};
export default {
	namespaced: true,
	state,
	mutations,
	actions
}